<template>
    <div id="form-signup">

        <div id="userForm">
            <h6 class="">{{ title }}</h6>

            <b-row class="p-0">
                <b-col>
                    <b-form-group label="* Nombre">
                        <b-form-input type="text" v-model="form.nombre" required />
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group label="* Apellidos">
                        <b-form-input type="text" v-model="form.apellidos" required />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row v-cloak class="p-0">
                <b-col>
                    <b-form-group label="* CURP">
                        <b-form-input type="text" v-model="form.curp" required maxlength="18" :state="validateCURP"
                            @input="form.curp = form.curp.toUpperCase()" />
                            <span class="local-tooltip" target="form-curp">
                                Requisito para la vinculación celular dispuesta por disposición oficial
                            </span>
                        <b-form-invalid-feedback :state="validateCURP">
                            El CURP debe tener 18 caracteres y seguir el formato válido
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row class="p-0">
                <b-col>
                    <b-form-group label="* Correo electrónico">
                        <b-form-input type="email" v-model="form.email" :disabled="lockEmail" required />
                    </b-form-group>
                </b-col>
                <b-col>
                    <b-form-group label="* Teléfono">
                        <b-form-input id="formTelefono" v-model="form.telefono" required />
                        <!-- 
                        <b-form-checkbox id="telefono-es-sky" name="telefono-es-sky" v-model="form.telefono_is_blackfon"
                            value="1" unchecked-value="0" class="mt-2" v-if="!isLogged">
                            Mi número es BLACKFON
                        </b-form-checkbox> 
                        -->
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row class="p-0">
                <b-col>
                    <b-form-group label="Nueva contraseña (Opcional)" v-if="newPasswordMode">
                        <b-form-input type="password" v-model="form.newPassword" autocomplete="new-password" />
                    </b-form-group>
                    <b-form-group v-else label="* Contraseña">
                        <b-form-input type="password" v-model="form.password" autocomplete="your-password" />
                    </b-form-group>
                </b-col>
                <b-col v-if="form.newPassword || form.password">
                    <b-form-group label="* Confirmar contraseña">
                        <b-form-input type="password" v-model="form.password_confirm" required />
                    </b-form-group>
                </b-col>
            </b-row>

        </div>

        <div id="userAddress" v-if="!disableAddress">

            <h6 class="">Datos de tu domicilio</h6>
            <hr class="c-hr" />

            <b-row class="p-0">

                <b-col>
                    <b-form-group label="* Estado">
                        <b-form-input type="text" v-model="form.estado" required />
                    </b-form-group>
                </b-col>

                <b-col>
                    <b-form-group label="* Ciudad">
                        <b-form-input type="text" v-model="form.ciudad" required />
                    </b-form-group>
                </b-col>

                <b-col>
                    <b-form-group label="* Colonia">
                        <b-form-input type="text" v-model="form.colonia" required />
                    </b-form-group>
                </b-col>

            </b-row>

            <b-row class="p-0">

                <b-col cols="6">
                    <b-form-group label="* Calle">
                        <b-form-input type="text" v-model="form.calle" required />
                    </b-form-group>
                </b-col>

                <b-col>
                    <b-form-group label="* Número">
                        <b-form-input type="text" v-model="form.numero" required />
                    </b-form-group>
                </b-col>

                <b-col>
                    <b-form-group label="* CP">
                        <b-form-input type="text" v-model="form.codigo_postal" required />
                    </b-form-group>
                </b-col>

            </b-row>

            <b-form-group>
                <b-form-checkbox id="form-facturacion" name="form-facturacion" v-model="form.facturacion" value="Si"
                    unchecked-value="No">
                    Facturación
                </b-form-checkbox>
            </b-form-group>

        </div>

        <div id="userBilling" v-if="form.facturacion == 'Si'">

            <h6 class="">Datos de facturación</h6>
            <hr class="c-hr" />

            <b-form-group label="* Persona">
                <b-form-select type="text" v-model="form.persona" required>
                    <b-form-select-option v-for="m in ['Física', 'Moral']" :key="m" :value="m">
                        {{ m }}
                    </b-form-select-option>
                </b-form-select>
            </b-form-group>

            <b-form-group label="* R. F. C.">
                <b-form-input type="text" v-model="form.rfc" required />
            </b-form-group>

            <b-form-group label="* Razón social">
                <b-form-input type="text" v-model="form.razonsocial" required />
            </b-form-group>

        </div>

    </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'

export default {
    name: 'formSignup',
    props: {
        newPasswordMode: {
            type: Boolean,
            default: false
        },
        lockEmail: {
            type: Boolean,
            default: false
        },
        disableAddress: {
            type: Boolean,
            default: true
        },
        title: {
            type: String,
            default: 'Crea tu cuenta'
        },
        value: {
            type: Object
        }
    },
    data: () => {
        return {
            form: {},
            mobi: {
                formTelefono: null,
            }
        }
    },
    computed: {
        ...mapGetters({
            isLogged: 'isLogged',
            getUser: 'authGetUser'
        })
    },
    methods: {
        validateCURP(){
            const curpPattern = /^[A-Z]{4}\d{6}[HM][A-Z]{5}[A-Z0-9]\d$/;
            return curpPattern.test(this.form.curp);
        },
        reviewValues(mode) {
            if (JSON.stringify(this.form) != JSON.stringify(this.value)) {
                switch (mode) {
                    case 'emit':
                        this.$emit('input', this.form)
                        break;
                    default:
                        this.form = _.clone(this.value)
                        break;
                }
            } else {
                console.log('same!')
            }
        }
    },
    mounted() {
        if (!this.value && !this.isLogged) {
            this.$emit('input', {
                nombre: null,
                apellidos: null,
                email: null,
                telefono: null,
                telefono_is_blackfon: 0,
                password: null,
                token: null,
                created: null,
                estatus: null,
                modificado: null,

                estado: null,
                ciudad: null,
                colonia: null,
                calle: null,
                numero: null,
                codigo_postal: null,

                persona: null,
                rfc: null,
                razonsocial: null,
                facturacion: 'No'
            })
        } else if (!this.value) {
            this.$emit('input', this.getUser)
        }
        // setTimeout(this.loadUpMobiPhone, 50)
    },
    updated() {
        this.reviewValues('emit')
    },
    watch: {
        value() {
            this.reviewValues()
        }
    }
}
</script>

<style lang="scss">
#userForm {
    .local-tooltip {
        font-size: 0.8rem;
        padding-left: 5px;
        color: #888;  
        display: inline-block;
    }
    .row {
        flex-flow: column;

        @media screen and (max-width: 768px) {
            // background-color: purple;
        }
    }
}
</style>